import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Breadcrumbs,
  Button,
  Grid,
  Link,
  SvgIcon,
  Typography
} from '@mui/material';
import {
  PlusCircle as PlusCircleIcon,
  Download as DownloadIcon,
  Upload as UploadIcon
} from 'react-feather';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { makeStyles } from '@mui/styles';
import { useDispatch } from "react-redux";
import { exportProducts } from "src/actions/mgmtProductAction";

const useStyles = makeStyles(() => ({
  root: {}
}));

function Header({ className,customerId,...rest }) {
  const classes = useStyles();
  const dispatch = useDispatch();

const handleExport = async () => {
  try {
    const response = await dispatch(exportProducts(customerId));

    if (!response.data.error) {
      window.open(response.data.data.gcExcelURL, "_blank");
    }
  } catch (err) {
    console.error(err);
  }
};

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justify="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Typography
            variant="h3"
            color="textPrimary"
            style={{marginLeft:"1em"}}
          >
          Product View
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item>
        <Button
          color="secondary"
          variant="contained"
          className={classes.action}
          component={RouterLink}
          to="/app/management/product/create"
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <PlusCircleIcon />
          </SvgIcon>
          New Product
        </Button>
      </Grid>
      <Grid item>
        <Button
          color="secondary"
          variant="contained"
          className={classes.action}
          component={RouterLink}
          to="/app/management/importcsv/view"
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <PlusCircleIcon />
          </SvgIcon>
          Upload Product Csv or Excel file
        </Button>
      </Grid>
<Grid item>
<Button
  color="secondary"
  variant="contained"
  onClick={handleExport}
  startIcon={<DownloadIcon size={18} />}
  style={{
   minWidth: "180px",
    height: "42px",
    whiteSpace: "nowrap",
    padding: "0 20px",
    textTransform: "uppercase",
    fontWeight: 600,
  }}
>
  Export Products
</Button>
</Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  customerId: PropTypes.number,
};

export default Header;
